const { paymentFieldsComponentAttribute } = window.PayoneerData;

export const getComponentNameByGatewayId = ( gatewayId ) => {
	const gatewayIdToComponentName = {
		'payoneer-checkout': 'cards',
		'payoneer-afterpay': 'afterpay',
		'payoneer-klarna': 'klarna',
		'payoneer-affirm': 'affirm',
		'payoneer-bancontact': 'bancontact',
		'payoneer-eps': 'eps',
		'payoneer-ideal': 'ideal',
		'payoneer-multibanco': 'multibanco',
		'payoneer-p24': 'p24',
	};

	return gatewayIdToComponentName[ gatewayId ];
};

export const mountSdkComponent = ( componentName, instance, sdk ) => {
	if ( !instance || !sdk.isAvailable( componentName ) ) {
		return;
	}

	const container = findComponentContainer( componentName );
	if ( !( container instanceof Element ) ) {
		return;
	}

	console.log( 'mountSdkComponent:', componentName, instance );
	instance.mount( container );
};

export const isRedirectComponent = ( instance ) => {
	if ( !( instance.element instanceof Element ) ) {
		return false;
	}

	return instance.element.id.includes( 'redirect' );
};

export const findComponentContainer = function ( componentName ) {
	return document.querySelector(
		`[${paymentFieldsComponentAttribute}=${componentName}]`
	);
};

export const normalizeComponentName = ( componentName, data ) => {
	/**
	 * For Stripe Connect merchant, we can get proper payment method name from `data.methodName`
	 * For older merchants, data.methodName doesn't exist, and we need componentName.
	 */
	componentName = data.methodName ?? componentName;

	/**
	 * Also, Stripe Connect uses 'card' instead of 'cards', so we need to fix it.
	 */
	return componentName === 'card' ? 'cards' : componentName;
};
